var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeoplesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.946,
    x2: 0.049,
    y2: 0.949,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c9efc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293462"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(-392 -212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1141",
    "data-name": "Rectangle 1141",
    width: 24,
    height: 24,
    rx: 4,
    transform: "translate(392 212)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-x",
    "data-name": "Icon feather-user-x",
    transform: "translate(395.853 211.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21414",
    "data-name": "Path 21414",
    d: "M14.794,27.818V26.045A3.545,3.545,0,0,0,11.249,22.5h-6.2A3.545,3.545,0,0,0,1.5,26.045v1.773",
    transform: "translate(0 -7.365)",
    fill: "none",
    stroke: "#fefefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21415",
    "data-name": "Path 21415",
    d: "M13.84,8.045A3.545,3.545,0,1,1,10.3,4.5,3.545,3.545,0,0,1,13.84,8.045Z",
    transform: "translate(-2.148)",
    fill: "none",
    stroke: "#fefefe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesIcon);
export default __webpack_public_path__ + "static/media/PeoplesIcon.5f85515fc9db8b51a13f16edc024e639.svg";
export { ForwardRef as ReactComponent };